import { FontHandler } from 'entities/FontPicker'
import { useConfigStore } from 'shared/store/configSlice'

export const FontPickerTR = () => {
  const font = useConfigStore().config?.tableReservationConfig?.font
  const updateTableReservationConfig = useConfigStore().updateTableReservationConfig

  return (
    <FontHandler
      key={`font_picker_${font}`}
      font={font || ''}
      updateFontHandler={updateTableReservationConfig}
    />
  )
}
